export default {
  ordersData: [],
  ordersTotal: 0,
  fetchOrdersPending: false,
  fetchOrdersError: null,

  auditLogData: [],
  auditLogTotal: 0,
  fetchAuditLogPending: false,
  fetchAuditLogError: null,

  stateCompareData: [],
  fetchStateComparePending: false,
  fetchStateCompareError: null,
};

